"use client"

import Link from "next/link"
import { Button } from "~/components/ui/button"
import { SignupIncentiveNote } from "./SignupIncentive"

type VisitorEmptyStateProps = {
  title: string
  description: string
  icon?: string
}

export function VisitorEmptyState({
  title,
  description,
  icon,
}: VisitorEmptyStateProps) {
  return (
    <div data-testid="visitor-empty-state" className="bg-white border border-border rounded-xl p-10 text-center max-w-md mx-auto mt-16">
      {icon && <div className="text-4xl mb-4">{icon}</div>}
      <h3 className="text-lg font-semibold text-neutral-emphasis mb-2">
        {title}
      </h3>
      <p className="text-sm text-neutral mb-6">{description}</p>
      <SignupIncentiveNote className="mb-6" />
      <div className="flex flex-col gap-3">
        <Button
          asChild
          className="bg-[#DE866D] hover:bg-[#C97257] text-white w-full"
        >
          <Link href="/signup">Sign Up</Link>
        </Button>
        <Button variant="outline" asChild className="w-full">
          <Link href="/loginpage">Log In</Link>
        </Button>
      </div>
    </div>
  )
}
